export function setLocation (state, data) {
  if (data) {
    state.location = data
  } else {
    state.location = null
  }
}

export function setAllLocations (state, data) {
  if (data) {
    state.all = data
  } else {
    state.all = null
  }
}
